import React from 'react';
import { useColorFamilies } from 'hooks';

export default Component => props => (
    <Component {...props} colorFamilies={useColorFamilies()} />
);
